import tokenCookie from "@/modules/tokenCookie";
import apiResponse from "@/modules/apiResponse";
const {hasValidToken, getToken} = tokenCookie();
const {errorResponse} = apiResponse();
import axios from "axios";
import Apis from "@/urls/apis";

const state = {
    coaches: {},
};
const getters = {
    getAllCoachesCounter: (state) => state.coaches.docs,
    getTotalCoachesCounter: (state) => state.coaches.totalDocs,
};
const actions = {
    async getAllCoachCounter({commit}, payload) {
        if (await hasValidToken()) {
            const header = {
                'Authorization': 'Bearer ' + getToken()
            };

            return new Promise((resolve, reject) => {
                axios.get(Apis.COUNTERMAN_ALL_COACH, {
                    params: payload,
                    headers: header
                })
                    .then(({data, status}) => {
                        if (status === 200) {
                            commit("setAllCoachCounter", data.coach)
                            resolve(data.coach)
                        }
                    })
                    .catch(error => {
                        reject(errorResponse(error))
                    });
            });
        }
    },
};
const mutations = {
    setAllCoachCounter: (state, allCoaches) => (state.coaches = allCoaches),
};

export default {
    state,
    getters,
    actions,
    mutations
};